export const CombinedShape = () => (
  <svg
    width="148"
    height="68"
    viewBox="0 0 148 68"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <linearGradient x1="14.755%" y1="54.472%" x2="90.596%" y2="47.392%" id="bq8dkx1y1c">
        <stop stopColor="#19B528" offset="0%" />
        <stop stopColor="#31D949" offset="100%" />
      </linearGradient>
      <filter
        x="-8.5%"
        y="-10.8%"
        width="116.9%"
        height="138.3%"
        filterUnits="objectBoundingBox"
        id="zjcadqizxa"
      >
        <feOffset dy="5" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation="3" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix
          values="0 0 0 0 0.407843137 0 0 0 0 0.607843137 0 0 0 0 0.878431373 0 0 0 0.24 0"
          in="shadowBlurOuter1"
        />
      </filter>
      <path
        d="M37 7c9.815 0 18.529 4.713 24.002 12H125c9.941 0 18 8.059 18 18s-8.059 18-18 18l-63.999.001C55.528 62.287 46.814 67 37 67 20.431 67 7 53.569 7 37 7 20.431 20.431 7 37 7z"
        id="cskpcr0eub"
      />
    </defs>
    <g transform="translate(-1 -6)" fill="none" fillRule="evenodd">
      <use fill="#000" filter="url(#zjcadqizxa)" xlinkHref="#cskpcr0eub" />
      <use fill="url(#bq8dkx1y1c)" xlinkHref="#cskpcr0eub" />
    </g>
  </svg>
);
